import { __assign } from "tslib";
import React from 'react';
import TiersBlock from '../../_partials/TiersBlock/TiersBlock';
export var MoreTiersBlock = function (props) {
    // TODO: stub for potential behavior differences with MoreTiersBlock
    return React.createElement(TiersBlock, __assign({}, props, { streamKey: "moreTiers" }));
};
MoreTiersBlock.displayName = 'MoreTiersBlock';
export default MoreTiersBlock;
//# sourceMappingURL=MoreTiersBlock.js.map